(() => {
  // --- Helpers shared with Feather ---
  function getSectionId() {
    // Feather keeps the main product section id on <variant-picker>
    return document.querySelector('variant-picker')?.getAttribute('data-section-id') || null;
  }

  function getVariantId() {
    return document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || null;
  }

  async function fetchSectionHTML(variantId, sectionId) {
    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Section fetch failed: ${res.status}`);
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  // --- Update Variant Metafield LIST blocks ---
  async function updateVariantMetafieldLists(variantId) {
    const sectionId = getSectionId();
    if (!sectionId || !variantId) return;

    let doc;
    try {
      doc = await fetchSectionHTML(variantId, sectionId);
    } catch (e) {
      console.warn('[variant-metafield-list] fetch failed', e);
      return;
    }

    document.querySelectorAll('.js-variant-metafield-list').forEach((el) => {
      const blockId = el.getAttribute('data-vml-block-id');
      const currentContent = el.querySelector('[data-metafield-content]');
      if (!blockId || !currentContent) return;

      const newContent = doc.querySelector(`.js-variant-metafield-list[data-vml-block-id="${blockId}"] [data-metafield-content]`);
      if (newContent) currentContent.innerHTML = newContent.innerHTML;
    });
  }

  // --- One global watcher (polling) ---
  // We poll because Feather button pickers can update variant id without firing reliable events.
  const stateKey = '__variantMetafieldWatcher__';
  window[stateKey] = window[stateKey] || { started: false, lastVariantId: null };

  function tick() {
    const v = getVariantId();
    if (v && v !== window[stateKey].lastVariantId) {
      window[stateKey].lastVariantId = v;
      updateVariantMetafieldLists(v);
      // If you already update lines in the same file, you can call that too here.
      // updateVariantMetafieldLines(v);
    }
  }

  if (!window[stateKey].started) {
    window[stateKey].started = true;

    // initial
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tick, { once: true });
    } else {
      tick();
    }

    // poll lightly
    setInterval(tick, 150);

    // optional: speed up on picker interaction
    document.addEventListener('click', (e) => {
      if (e.target.closest('variant-picker')) requestAnimationFrame(tick);
    });
  } else {
    // watcher already running; just do one immediate update for current variant
    tick();
  }
})();